import appConstants from '../../../../../../../../../appConstants';
import { NumericEditor, TextFieldEditor } from '@dataGrid/components/cellEditors';
import { MultiSelectFilter } from '@dataGrid/components/columnFilters';
import { getCustomerName } from '../../../../../../../../modules/IBPlanning/ShipmentsView/utils';
import CheckBoxRenderer from '../../../CheckBoxRenderer';
import DotRenderer from '../../../DotRenderer';
import {
  CheckIfAllProIncluded,
  checkIfProIncluded,
  checkIsNotModified,
  handleCheckboxToggle,
  handleCheckboxToggleForAll
} from '../../utils';

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = 'GridConfiguration';
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.IncorrectPseValidationGrid,
      keyColumn: 'proId',
      rowSelection: 'multiple',
      rowDeselection: 'true',
      defaultColDef: {
        cellEditor: TextFieldEditor,
        sortable: true,
        filter: true,
        resizable: true
      },
      columns: [
        {
          headerName: '',
          cellRenderer: CheckBoxRenderer,
          headerComponent: CheckBoxRenderer,
          valueGetter: (params) => checkIfProIncluded(params),
          cellRendererParams: (params) => ({
            onChange: (isChecked) => handleCheckboxToggle(params, isChecked)
          }),
          headerComponentParams: (params) => ({
            value: CheckIfAllProIncluded(params),
            onChange: (isChecked) => handleCheckboxToggleForAll(params, isChecked)
          }),
          headerClass: 'checkBoxHeader',
          cellClassRules: {
            'gridCell-centerAlign': true
          },
          pinned: 'left',
          lockPosition: true,
          lockPinned: true,
          isInvisibleInShowHide: true,
          minWidth: appConstants.columnWidth.W_64,
          maxWidth: appConstants.columnWidth.W_64
        },
        {
          headerName: '',
          pinned: "left",
          minWidth: appConstants.columnWidth.VIOLATION_DOT,
          maxWidth: appConstants.columnWidth.VIOLATION_DOT,
          valueGetter: checkIsNotModified,
          lockPosition: true,
          lockPinned: true,
          cellClass: ['gridCell-centerAlign', "gridCell-dot"],
          filter: false,
          cellRenderer: DotRenderer
        },
        {
          headerName: 'Pro#',
          field: 'proId',
          headerTooltip: 'Pro ID',
          minWidth: appConstants.columnWidth.PROID,
          filter: MultiSelectFilter,
          filterParams: {
            filterType: appConstants.FILTER_TYPES.STRING
          }
        },
        {
          headerName: 'Customer',
          headerTooltip: 'Customer Name',
          // Need to update the below field to customer name
          field: 'consigneeName',
          minWidth: appConstants.columnWidth.CUSTOMER,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter,
          valueGetter: getCustomerName,
          tooltipValueGetter: (params) => params.value
        },
        {
          headerName: 'HU',
          headerTooltip: 'Handling Unit',
          field: 'hu',
          minWidth: appConstants.columnWidth.HU,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Pieces',
          headerTooltip: 'Pieces',
          field: 'pieces',
          minWidth: appConstants.columnWidth.PIECES,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Pallet Count',
          headerTooltip: 'Pallet Count',
          field: 'palletCount',
          minWidth: appConstants.columnWidth.PALLET_COUNT,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Package Type',
          headerTooltip: 'Package Type',
          field: 'packageType',
          cellClass: 'gridCell-leftAlign',
          minWidth: appConstants.columnWidth.PACKAGE_TYPE,
          filter: MultiSelectFilter
        },
        {
          headerName: 'Cube',
          headerTooltip: 'Cubic Feet',
          field: 'cube',
          minWidth: appConstants.columnWidth.CUBIC_FEET,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'Weight',
          headerTooltip: 'Weight',
          field: 'weight',
          minWidth: appConstants.columnWidth.WEIGHT,
          cellClass: 'gridCell-leftAlign',
          filter: MultiSelectFilter
        },
        {
          headerName: 'PSE',
          headerTooltip: 'Pallet Space Equivalent',
          field: 'pse',
          minWidth: appConstants.columnWidth.PSE,
          cellClass: 'gridCell-leftAlign',
          editable: true,
          filter: MultiSelectFilter,
          cellEditor: NumericEditor
        }
      ]
    };
  }
}
